import { Cohort, StressValue } from 'root-constants'
import { PageId } from 'page-constants'

export const QUESTION = 'Thanks for sharing!'

export const STRESS_LEVEL_COLOR_MAP = {
  [StressValue.LOW]: '#16cdff',
  [StressValue.MODERATE]: '#ff8800',
  [StressValue.SEVERE]: '#fa5476',
}

export const EMAIL_PAGES_MAP: Record<Cohort, PageId> = {
  [Cohort.VARIANT_ONE]: PageId.ENTER_EMAIL,
  [Cohort.VARIANT_TWO]: PageId.ENTER_EMAIL_V2,
}
